import { render, staticRenderFns } from "./SearchB2C.vue?vue&type=template&id=47657802&"
import script from "./SearchB2C.ts?vue&type=script&lang=ts&"
export * from "./SearchB2C.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports